import { MetricDomain } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';
import { QueryResponseTypes } from '@mode/shared/data-access-webapp';

export const metricDialogLoadMetrics = createAction('[Metric Dialog] Load Metrics');

export const metricDialogLoadMetricsSuccess = createAction(
  '[Metric Dialog] Load Metrics Success',
  props<{ metrics: ReadonlyArray<MetricDomain.Metric> }>()
);

export const metricDialogLoadMetricsFailure = createAction(
  '[Metric Dialog] Load Metrics Failure',
  props<{ error: any }>()
);

export const metricsRunComplete = createAction(
  '[Metric] Metric Run Complete',
  props<{
    metricToken: string;
    queryToken: string;
  }>()
);

export const metricQueryRouteSelectMetric = createAction(
  '[Metric Query Route] Select Metric',
  props<{ metricToken: string }>()
);

export const metricQueryRouteSelectVizType = createAction(
  '[Metric Query Route] Select Viz Type',
  props<{ vizType: MetricDomain.VizTypeSelection }>()
);

export const metricQueryRouteLoadMetric = createAction(
  '[Metric Query Route] Load Metric',
  props<{ metricToken: string }>()
);

export const metricQueryRouteLoadMetricSuccess = createAction(
  '[Metric Query Route] Load Metric Success',
  props<{ metric: MetricDomain.Metric }>()
);
export const metricQueryRouteLoadMetricFailure = createAction(
  '[Metric Query Route] Load Metric Failure',
  props<{ error: Error }>()
);

export const createMetricQuery = createAction(
  '[Metric Query Route] Create Metric Query',
  props<{
    dataSourceId?: string;
    metricToken: string;
    vizType: MetricDomain.VizTypeSelection;
  }>()
);

export const createMetricQuerySuccess = createAction(
  '[Metric Query Route] Create Metric Query Success',
  props<{
    metricToken: string;
    vizType: MetricDomain.VizTypeSelection;
    query: QueryResponseTypes.MetricQueryResource;
  }>()
);

export const initChartStateIfUnset = createAction(
  '[Metric Query] Init Chart State If Unset',
  props<{
    token: string;
    state: MetricDomain.ChartState;
  }>()
);

export const setChartState = createAction(
  '[Metric Query] Set Chart State',
  props<{
    token: string;
    state: MetricDomain.ChartState;
  }>()
);

export const setSelectedQueryRawSql = createAction(
  '[Metric Query] Set Selected Query Raw Sql',
  props<{
    rawSql: string | null;
  }>()
);

export type Union =
  | ReturnType<typeof metricDialogLoadMetrics>
  | ReturnType<typeof metricDialogLoadMetricsSuccess>
  | ReturnType<typeof metricDialogLoadMetricsFailure>
  | ReturnType<typeof metricQueryRouteSelectMetric>
  | ReturnType<typeof metricQueryRouteSelectVizType>
  | ReturnType<typeof metricQueryRouteLoadMetric>
  | ReturnType<typeof metricQueryRouteLoadMetricSuccess>
  | ReturnType<typeof metricQueryRouteLoadMetricFailure>
  | ReturnType<typeof createMetricQuery>
  | ReturnType<typeof createMetricQuerySuccess>
  | ReturnType<typeof metricsRunComplete>
  | ReturnType<typeof initChartStateIfUnset>
  | ReturnType<typeof setChartState>
  | ReturnType<typeof setSelectedQueryRawSql>;
